<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
      <form
      @submit="saveData"
      method="post"
      >
          <h3 v-if="isEditing">
            {{ $t('button.edit') }} {{ $t('delivery_types.label') }}
          </h3>
          <h3 v-else>{{ $t('button.create') }} {{ $t('delivery_types.label') }}</h3>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.name')" type="text" placeholder="Ej: Producto" v-model="product.name" required></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.price')" type="text" prepend="$" placeholder="Ej: 25.50" v-model="product.price" required></CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-row align-items-end" v-if="productUrl !== ''">
                <div class="p-2">
                  <img :src="productUrl">
                </div>
                <div class="p-2">
                  <CButton color="primary" @click="deleteImage()">
                    <CIcon :content="$options.deleteIcon" />
                  </CButton>
                </div>
              </div>
              <label>Image</label>
              <CInputFile
                  type="file"
                  v-on:change="handleFileUpload"
                  placeholder="New file"
                  ref="productImage"
              />
            </div>
          </div>
          <CButton color="success" type="submit">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
          </form>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilBan, cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'FormProduct',
  mixins: [formMixin, localeMixin],
  deleteIcon: cilBan,
  updateIcon: cilSync,
  addIcon: cilPlus,
  backIcon: cilArrowLeft,
  data() {
    return {
        product: {
          name: '',
          price: '',
          image: '',
          imagePath: ''
        },
        productUrl: '',
        productId: null
    }
  },
  mounted() {
    if (this.isEditing) {
        this.getProduct();
        this.productId = this.$route.params.id;
    }
  },
  methods: {
      showAlertError() {
          if (this.message != "") {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: this.message,
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          } else {
              this.$swal({
                  title: i18n.t('modal.title'),
                  text: i18n.t('modal.body'),
                  icon: 'warning',
                  showCancelButton: true,
                  cancelButtonColor: '#d33',
              });
          }
      },
    goBack() {
      this.$router.push({ name: "Products" });
    },
    showAlert () {
      if (this.isEditing) {
        this.$swal(
          i18n.t('delivery_types.modal.updated_label'),
          i18n.t('delivery_types.modal.updated_body'),
          'success'
        ).then(result => {
          this.goBack();
        });
      } else {
        this.$swal(
          i18n.t('delivery_types.modal.created_label'),
          i18n.t('delivery_types.modal.created_body'),
          'success'
        ).then(result => {
          this.goBack();
        });
      }
    },
    handleFileUpload(files, event) {
        let formData = new FormData();
        formData.append('file', files[0]);
        axios.post('/api/products/file/store?token=' + localStorage.getItem("api_token"),
            formData,
            { headers: {
                'Content-Type': 'multipart/form-data'
            }}
        ).then(response => {
            const data = response.data;
            if (data.status === 'success') {
              this.product.image = data.file;
              this.productUrl = data.url;
            }
        })
        .catch(function(error){
            console.log(error)
            self.showAlertError();
        });
    },
    deleteImage() {
      // we need to delete the image by filename
      const fileName = this.product.image;
      const data = { filePath: fileName, id: productId };
      const token = localStorage.getItem("api_token")
      axios.post('/api/products/file/delete?token='+token, data)
      .then(response => {
        const data = response.data;
        if (data.status === 'success') {
          this.productUrl = '';
          this.product.image = '';
          this.$refs.productImage.$el.firstElementChild.value = '';
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getProduct() {
        const id = this.$route.params.id;
        axios.get('/api/products/'+ id + '?token=' + localStorage.getItem("api_token"))
        .then(response => {
            const data = response.data;
            this.product.name = data.name;
            this.product.price = data.price;
            this.productUrl = data.imageUrl;
        }).catch(error => {
            console.log(error);
            this.showAlertError();
        });
    },
    saveData(e) {
        e.preventDefault();
        const data = this.product;
        this.$emit("saved", data);
        let url = `/api/products`;
        let sendRequest = null;

        if (this.isEditing) {
            url = url + "/" + this.$route.params.id + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.put(url, data);
                    if (response.data.status === "success") {
                        this.showAlert();
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlertError();
                    } else{
                        console.log(error);
                        this.showAlertError();
                    }
                }
            };
        } else {
            url = url + '?token=' + localStorage.getItem("api_token");
            sendRequest = async() => {
                try {
                    const response = await axios.post(url, data);
                    if (response.data.status === "success") {
                        this.product = {
                          name: '',
                          price: '',
                        };
                        this.showAlertError();
                    }
                } catch (error) {
                    if(error.response.data.message == 'The given data was invalid.'){
                        this.message = '';
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                this.message += error.response.data.errors[key][0] + '  ';
                            }
                        }
                        this.showAlertError();
                    } else{
                        console.log(error);
                        this.showAlertError();
                    }
                }
            };
        }
        sendRequest();
        return data;
    },
  }
}

</script>

<style scoped>
.card-body img {
  width: 200px;
  height: 200px
}
</style>
